


















import { IBounceInfo } from '@/types/data-objects/item-histories'
import Vue from 'vue'

export default Vue.extend({
  name: 'BounceCapsule',

  props: {
    bounceInfo: {
      type: Object as () => IBounceInfo,
      required: true,
    },
  },
})
